import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Export")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBar = _resolveComponent("SearchBar")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, { direction: "horizontal" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, { width: "300px" }, {
        default: _withCtx(() => [
          _createVNode(_component_SearchBar, {
            useSearch: true,
            useTrainingStatus: true,
            useOrganizationGroups: true,
            tagType: 'crash-file',
            onSearchChange: _ctx.atSearchChange,
            onStatusChange: _ctx.atStatusChange,
            onTrainingStatusChange: _ctx.atTrainingStatusChange,
            onOrganizationGroupChange: _ctx.atOrganizationGroupChange,
            onTagQueryChange: _ctx.atTagQueryChange,
            onTagMatchChange: _ctx.atTagMatchChange
          }, null, 8, ["onSearchChange", "onStatusChange", "onTrainingStatusChange", "onOrganizationGroupChange", "onTagQueryChange", "onTagMatchChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { direction: "vertical" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_table, {
            data: _ctx.crashFiles,
            stripe: "",
            "default-expand-all": true,
            onSortChange: _ctx.onSortChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "title",
                label: "Title",
                sortable: "custom"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_link, {
                    href: `/#/crashfiles/${row._id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ]),
                _: 1
              }),
              (_ctx.isVAR || _ctx.isSuperAdmin)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: "Organization"
                  }, {
                    default: _withCtx(({row}) => [
                      _createTextVNode(_toDisplayString(_ctx.orgMap[row.org]), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, { label: "User" }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.getName(row)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "Group" }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.getGroup(row)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "training",
                label: "Test Drive"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row.training ? 'Yes' : 'No'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "date_created",
                label: "Created",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.convertDateString(scope.row.date_created, _ctx.userPrefs?.timezone)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "Options" }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    icon: "el-icon-download",
                    onClick: () => _ctx.downloadCrashFile(row._id)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSortChange"]), [
            [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
          ]),
          _createVNode(_component_el_pagination, {
            class: "margin-auto margin-vert",
            background: "",
            layout: "sizes, prev, pager, next",
            "page-sizes": [10, 20, 50, 100, 200],
            total: _ctx.total,
            "page-size": _ctx.pageSize,
            "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageSize = $event)),
            "current-page": _ctx.page,
            "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => (_ctx.page = $event))
          }, null, 8, ["total", "page-size", "current-page"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
  ])
}